(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["biome-nutrition-bloat"] && !Shopify.designMode) return;
  try {
    (function () {
  var panel = document.querySelector('[data-nfb-panel]');
  var back = document.querySelector('[data-nfb-back]');
  if (!panel || !back) return;
  var bodyEl = panel.querySelector('[data-nfb-body]');
  var state = { open: false };

  function open() {
    state.open = true;
    panel.classList.add('nfm--open');
    panel.setAttribute('aria-hidden', 'false');
    back.classList.add('drawer-back--open');
    document.body.style.overflow = 'hidden';
    if (bodyEl) bodyEl.scrollTop = 0;
  }
  function close() {
    state.open = false;
    panel.classList.remove('nfm--open');
    panel.setAttribute('aria-hidden', 'true');
    back.classList.remove('drawer-back--open');
    document.body.style.overflow = '';
  }

  back.addEventListener('click', close);
  var closeBtn = panel.querySelector('[data-nfb-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) close(); });
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bx-nutrition]');
    if (!trigger) return;
    e.preventDefault();
    open();
  });

  window.BiomeNutrition = { open: open, close: close };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["biome-nutrition-metab"] && !Shopify.designMode) return;
  try {
    (function () {
  var panel = document.querySelector('[data-nfmb-panel]');
  var back = document.querySelector('[data-nfmb-back]');
  if (!panel || !back) return;
  var bodyEl = panel.querySelector('[data-nfmb-body]');
  var state = { open: false };

  function open() {
    state.open = true;
    panel.classList.add('nfm--open');
    panel.setAttribute('aria-hidden', 'false');
    back.classList.add('drawer-back--open');
    document.body.style.overflow = 'hidden';
    if (bodyEl) bodyEl.scrollTop = 0;
  }
  function close() {
    state.open = false;
    panel.classList.remove('nfm--open');
    panel.setAttribute('aria-hidden', 'true');
    back.classList.remove('drawer-back--open');
    document.body.style.overflow = '';
  }

  back.addEventListener('click', close);
  var closeBtn = panel.querySelector('[data-nfmb-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) close(); });
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bx-nutrition]');
    if (!trigger) return;
    e.preventDefault();
    open();
  });

  window.BiomeNutrition = { open: open, close: close };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["biome-nutrition-panel"] && !Shopify.designMode) return;
  try {
    (function () {
  // The snippet is mounted by the header on commerce pages AND by content sections
  // (bundle-faq, contact-faqs, ingredients-hero), so some pages carry two copies of
  // the markup. {% javascript %} runs once, binding the first — drop any extras.
  var allPanels = document.querySelectorAll('[data-nutrition-panel]');
  var allBacks = document.querySelectorAll('[data-nutrition-back]');
  for (var d = 1; d < allPanels.length; d++) allPanels[d].remove();
  for (var d2 = 1; d2 < allBacks.length; d2++) allBacks[d2].remove();

  var panel = document.querySelector('[data-nutrition-panel]');
  var back = document.querySelector('[data-nutrition-back]');
  if (!panel || !back) return;
  var tabsEl = panel.querySelector('[data-nutrition-tabs]');
  var flavorsEl = panel.querySelector('[data-nutrition-flavors]');
  var bodyEl = panel.querySelector('[data-nutrition-body]');

  // --- DATA (copied verbatim from the design prototype) ---------------------
  var NUTRITION_DATA = {
    vanilla: {
      name: "Vanilla-Caramel",
      facts: {
        servings: 14,
        serving: "1 Packet (94g)",
        calories: 350,
        rows: [
          { l: "Total Fat",         v: "12g",    dv: "15%", bold: true },
          { l: "Saturated Fat",     v: "5g",     dv: "25%", indent: true },
          { l: "Trans Fat",         v: "0g",     dv: "—",   indent: true },
          { l: "Cholesterol",       v: "0mg",    dv: "0%",  bold: true },
          { l: "Sodium",            v: "280mg",  dv: "12%", bold: true },
          { l: "Total Carbohydrates", v: "28g",  dv: "10%", bold: true },
          { l: "Dietary Fiber",     v: "12g",    dv: "43%", indent: true },
          { l: "Total Sugars",      v: "<1g",    dv: "—",   indent: true },
          { l: "0g Added Sugars",   v: "—",      dv: "0%",  indent: true },
          { l: "Protein",           v: "40g",    dv: "80%", bold: true }
        ],
        vitamins: [
          ["Vitamin D",      "5.0mcg",  "25%"],
          ["Calcium",        "520mg",   "40%"],
          ["Iron",           "10mg",    "60%"],
          ["Potassium",      "940mg",   "20%"],
          ["Vitamin A",      "800mcg",  "90%"],
          ["Vitamin C",      "80mg",    "90%"],
          ["Vitamin E",      "12.0mg",  "80%"],
          ["Vitamin K",      "75mcg",   "60%"],
          ["Thiamin",        "1.2mg",   "110%"],
          ["Riboflavin",     "1.4mg",   "110%"],
          ["Niacin",         "16.0mg",  "100%"],
          ["Vitamin B6",     "1.4mg",   "80%"],
          ["Folate (340mcg DFE)", "200mcg folic acid", "90%"],
          ["Vitamin B12",    "2.5mcg",  "100%"],
          ["Biotin",         "50.0mcg", "170%"],
          ["Pantothenic Acid","6.0mg", "120%"],
          ["Phosphorus",     "375mg",   "30%"],
          ["Iodine",         "150mcg",  "100%"],
          ["Magnesium",      "330mg",   "79%"],
          ["Zinc",           "5.5mg",   "50%"],
          ["Selenium",       "55mcg",   "100%"],
          ["Copper",         "1mg",     "110%"],
          ["Manganese",      "2.0mg",   "90%"],
          ["Chromium",       "40.0mcg", "110%"],
          ["Molybdenum",     "50.0mcg",  "110%"]
        ]
      },
      ingredients: "Rice Protein Concentrate, Pea Protein Isolate, Oat Flakes Flour, Coconut Fat MCT Powder, Hemp Seed Protein Powder, Sunflower Oil, Natural Vanilla Flavor, Caramel Extract, Psyllium Husk Powder (Plantago ovata) (seed husk), Acacia, Potassium Chloride, Guar Gum, Calcium Carbonate, Calcium Phosphate, Magnesium Citrate, Magnesium Oxide, Choline Bitartrate, Sucralose, Ascorbic Acid, Inositol, Astaxanthin, Ferrous Sulfate, DL-alpha-Tocopheryl Acetate, Aphanizomenon flos-aquae Powder, Kelp Powder, Chlorella Powder, Niacinamide, Spirulina Powder, Bifidobacterium longum, Lactobacillus acidophilus, Calcium Pantothenate, Zinc Oxide, Manganese Sulfate, Vitamin A Acetate, Copper Sulfate, Ergocalciferol, Pyridoxine Hydrochloride (Vitamin B6), Menaquinone-7, Thiamine Hydrochloride, Riboflavin, Phytonadione, Folic Acid, Vitamin B12, Chromium Chloride, Potassium Iodide, Sodium Molybdate, Sodium Selenite, D-Biotin, Alpha-Amylase, Protease, Lactase, Cellulase, Lipase."
    },
    chocolate: {
      name: "Chocolate",
      facts: {
        servings: 14,
        serving: "1 Packet (94g)",
        calories: 350,
        rows: [
          { l: "Total Fat",         v: "12g",    dv: "15%", bold: true },
          { l: "Saturated Fat",     v: "5g",     dv: "25%", indent: true },
          { l: "Trans Fat",         v: "0g",     dv: "—",   indent: true },
          { l: "Cholesterol",       v: "0mg",    dv: "0%",  bold: true },
          { l: "Sodium",            v: "280mg",  dv: "12%", bold: true },
          { l: "Total Carbohydrates", v: "28g",  dv: "10%", bold: true },
          { l: "Dietary Fiber",     v: "13g",    dv: "46%", indent: true },
          { l: "Total Sugars",      v: "<1g",    dv: "—",   indent: true },
          { l: "0g Added Sugars",   v: "—",      dv: "0%",  indent: true },
          { l: "Protein",           v: "39g",    dv: "78%", bold: true }
        ],
        vitamins: [
          ["Vitamin D",      "5.0mcg",  "25%"],
          ["Calcium",        "520mg",   "40%"],
          ["Iron",           "10mg",    "60%"],
          ["Potassium",      "940mg",   "20%"],
          ["Vitamin A",      "800mcg",  "90%"],
          ["Vitamin C",      "80mg",    "90%"],
          ["Vitamin E",      "12.0mg",  "80%"],
          ["Vitamin K",      "75mcg",   "60%"],
          ["Thiamin",        "1.2mg",   "110%"],
          ["Riboflavin",     "1.4mg",   "110%"],
          ["Niacin",         "16.0mg",  "100%"],
          ["Vitamin B6",     "1.4mg",   "80%"],
          ["Folate (340mcg DFE)", "200mcg folic acid", "90%"],
          ["Vitamin B12",    "2.5mcg",  "100%"],
          ["Biotin",         "50.0mcg", "170%"],
          ["Pantothenic Acid","6.0mg", "120%"],
          ["Phosphorus",     "375mg",   "30%"],
          ["Iodine",         "150mcg",  "100%"],
          ["Magnesium",      "330mg",   "79%"],
          ["Zinc",           "5.5mg",   "50%"],
          ["Selenium",       "55mcg",   "100%"],
          ["Copper",         "1mg",     "110%"],
          ["Manganese",      "2.0mg",   "90%"],
          ["Chromium",       "40.0mcg", "110%"],
          ["Molybdenum",     "50.0mcg",  "110%"]
        ]
      },
      ingredients: "Rice Protein Concentrate, Pea Protein Isolate, Oat Flakes Flour, Coconut Fat MCT Powder, Hemp Seed Protein Powder, Sunflower Oil, Lowfat Cocoa Powder, Psyllium Husk Powder (Plantago ovata) (seed husk), Natural Flavor, Acacia, Potassium Chloride, Guar Gum, Calcium Carbonate, Calcium Phosphate, Magnesium Citrate, Magnesium Oxide, Choline Bitartrate, Sucralose, Ascorbic Acid, Inositol, Astaxanthin, Ferrous Sulfate, DL-alpha-Tocopheryl Acetate, Aphanizomenon flos-aquae Powder, Kelp Powder, Chlorella Powder, Niacinamide, Spirulina Powder, Bifidobacterium longum, Lactobacillus acidophilus, Calcium Pantothenate, Zinc Oxide, Manganese Sulfate, Vitamin A Acetate, Copper Sulfate, Ergocalciferol, Pyridoxine Hydrochloride (Vitamin B6), Menaquinone-7, Thiamine Hydrochloride, Riboflavin, Phytonadione, Folic Acid, Vitamin B12, Chromium Chloride, Potassium Iodide, Sodium Molybdate, Sodium Selenite, D-Biotin, Alpha-Amylase, Protease, Lactase, Cellulase, Lipase."
    }
  };

  var METAB_FACTS = {
    serving: "2 capsules",
    servings: 14,
    rows: [
      { l: "L-Carnitine Tartrate",         v: "788 mg", dv: "**" },
      { l: "Green Tea Leaf Extract",       v: "200 mg", dv: "**", note: "15% EGCG · 7% caffeine" },
      { l: "Ginger Root Extract",          v: "140 mg", dv: "**", note: "5% gingerols" },
      { l: "Guarana Seed Extract",         v: "100 mg", dv: "**", note: "12% caffeine" },
      { l: "Green Coffee Bean Extract",    v: "50 mg",  dv: "**", note: "50% chlorogenic acid" }
    ],
    caffeineTotal: "≈26 mg per serving (less than ¼ cup of coffee)",
    others: "Hydroxypropyl methylcellulose (vegan capsule), microcrystalline cellulose, magnesium stearate (plant-source), silicon dioxide.",
    directions: "Take 2 capsules per day with breakfast and a full glass of water. For best results, use consistently for at least 8 weeks. Do not exceed the recommended dose.",
    warnings: "Contains caffeine. Not for use by pregnant or breastfeeding women, children under 18, or persons with known medical conditions. Consult your physician before use if you are taking medication.",
    allergens: "Vegan · gluten-free · non-GMO. No soy, dairy, eggs, nuts, or shellfish."
  };

  var BLOAT_FACTS = {
    serving: "4 capsules",
    servings: 14,
    rows: [
      { l: "Psyllium Husk Powder",         v: "1,300 mg", dv: "**" },
      { l: "Proprietary Probiotic Blend",  v: "624 mg",   dv: "**",
        note: "52 Billion CFU — Bifidobacterium animalis subsp. lactis BLa80, Lactobacillus paracasei LbC86, Bifidobacterium longum subsp. longum BL21, Lactobacillus rhamnosus LRa05, Lactobacillus acidophilus LAc5, Lactobacillus plantarum Lp90, Bifidobacterium breve BR60, Lactobacillus casei Lc89, Streptococcus salivarius subsp. thermophilus ST81, Lactobacillus salivarius LS97" },
      { l: "Betaine Hydrochloride",        v: "262 mg",   dv: "**" },
      { l: "Protease",                     v: "50 mg",    dv: "**" },
      { l: "Bromelain",                    v: "50 mg",    dv: "**" },
      { l: "Papain",                       v: "50 mg",    dv: "**" },
      { l: "Cellulase",                    v: "17.4 mg",  dv: "**" }
    ],
    others: "Hydroxypropyl methylcellulose (HPMC, vegan capsule), microcrystalline cellulose, magnesium stearate.",
    directions: "Take 4 capsules daily, preferably after a meal. Maintain adequate daily fluid intake as recommended for your age, height, and weight. Capsules can be taken with or without food. For best results, use in conjunction with the Biome Secret Superfood Shake as part of a healthy lifestyle. Do not exceed the recommended dosage.",
    warnings: "Not for use by children under 12. Consult your physician before use if you are pregnant, breastfeeding, have a medical condition, or take medication (especially immunosuppressants).",
    allergens: "Vegan · gluten-free · non-GMO. No soy, dairy, eggs, nuts, or shellfish."
  };

  // TABS — tab thumbnails reuse the product shots from the bundle daily-protocol section.
  var TABS = [
    { id: "shake", lbl: "Shake",            img: "https://cdn.shopify.com/s/files/1/0735/8742/5546/files/shake.avif" },
    { id: "metab", lbl: "Metabolism+",      img: "https://cdn.shopify.com/s/files/1/0735/8742/5546/files/metabolism-booster.avif" },
    { id: "bloat", lbl: "Bloating Relief+", img: "https://cdn.shopify.com/s/files/1/0735/8742/5546/files/bloating-relief.avif" }
  ];
  var FLAVORS = [
    { id: "chocolate", lbl: "Chocolate" },
    { id: "vanilla",   lbl: "Vanilla-Caramel" }
  ];

  var state = { open: false, product: "shake", flavor: "chocolate" };

  // --- helpers --------------------------------------------------------------
  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  function renderShake(flavorKey) {
    var d = NUTRITION_DATA[flavorKey];
    if (!d) return "<p>Nutrition data unavailable.</p>";
    var f = d.facts;
    var html = '';
    html += '<h2 class="h2 allin-nfm__h allin-nfm__h--xl">Nutrition Facts — ' + esc(d.name) + '</h2>';
    html += '<div class="nf">';
    html += '<div class="nf__top">';
    html += '<div>' + esc(f.servings) + ' Servings per Container</div>';
    html += '<div>Serving size <strong>' + esc(f.serving) + '</strong></div>';
    html += '</div>';
    html += '<div class="nf__cal"><span class="nf__cal-l">Calories</span><span class="nf__cal-v">' + esc(f.calories) + '</span></div>';
    html += '<div class="nf__head"><span>Amount per Serving</span><span>% Daily Value*</span></div>';
    f.rows.forEach(function (r) {
      var cls = "nf__row" + (r.bold ? " nf__row--bold" : "") + (r.indent ? " nf__row--indent" : "");
      html += '<div class="' + cls + '"><span>' + esc(r.l) + '</span><span class="nf__row-v">' + esc(r.v) + '</span><span class="nf__row-dv">' + esc(r.dv) + '</span></div>';
    });
    html += '<div class="nf__divider"></div>';
    f.vitamins.forEach(function (vit) {
      html += '<div class="nf__row nf__row--vit"><span>' + esc(vit[0]) + '</span><span class="nf__row-v">' + esc(vit[1]) + '</span><span class="nf__row-dv">' + esc(vit[2]) + '</span></div>';
    });
    html += '<div class="nf__foot">* The % Daily Value (DV) tells you how much a nutrient in a serving of food contributes to a daily diet. 2,000 calories a day is used for general nutrition advice.</div>';
    html += '</div>';
    html += '<h2 class="h2 allin-nfm__h allin-nfm__h--lg">Ingredients</h2>';
    html += '<p class="body-md allin-nfm__prose">' + esc(d.ingredients) + '</p>';
    return html;
  }

  function renderCapsule(factsObj, title) {
    if (!factsObj) return "<p>Supplement data unavailable.</p>";
    var html = '';
    html += '<h2 class="h2 allin-nfm__h allin-nfm__h--xl">Supplement Facts — ' + esc(title) + '</h2>';
    html += '<div class="nf">';
    html += '<div class="nf__top">';
    html += '<div>' + esc(factsObj.servings) + ' Servings per Container</div>';
    html += '<div>Serving size <strong>' + esc(factsObj.serving) + '</strong></div>';
    html += '</div>';
    html += '<div class="nf__head"><span>Amount per Serving</span><span>% Daily Value*</span></div>';
    factsObj.rows.forEach(function (r) {
      var noteHtml = r.note
        ? '<span class="nf__row-note">' + esc(r.note) + '</span>'
        : '';
      html += '<div class="nf__row"><span>' + esc(r.l) + noteHtml + '</span><span class="nf__row-v">' + esc(r.v) + '</span><span class="nf__row-dv">' + esc(r.dv) + '</span></div>';
    });
    html += '<div class="nf__foot">* Percent Daily Values based on a 2,000-calorie diet.<br>** Daily Value not established.</div>';
    html += '</div>';
    if (factsObj.caffeineTotal) {
      html += '<div class="allin-nfm__pill"><strong>Total caffeine</strong> — ' + esc(factsObj.caffeineTotal) + '</div>';
    }
    if (factsObj.others) {
      html += '<h2 class="h2 allin-nfm__h allin-nfm__h--md">Other Ingredients</h2>';
      html += '<p class="body-md allin-nfm__prose">' + esc(factsObj.others) + '</p>';
    }
    if (factsObj.directions) {
      html += '<h2 class="h2 allin-nfm__h allin-nfm__h--sm">How to take</h2>';
      html += '<p class="body-md allin-nfm__prose">' + esc(factsObj.directions) + '</p>';
    }
    if (factsObj.allergens) {
      html += '<h2 class="h2 allin-nfm__h allin-nfm__h--sm">Allergens</h2>';
      html += '<p class="body-md allin-nfm__prose">' + esc(factsObj.allergens) + '</p>';
    }
    if (factsObj.warnings) {
      html += '<h2 class="h2 allin-nfm__h allin-nfm__h--sm">Warning</h2>';
      html += '<p class="body-md allin-nfm__prose--muted">' + esc(factsObj.warnings) + '</p>';
    }
    return html;
  }

  var TRUST = '<div class="allin-nfm__trust">' +
    '<span class="allin-nfm__trust-icon">' +
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none">' +
      '<path d="M12 2l9 3v6c0 5-4 9-9 10-5-1-9-5-9-10V5l9-3z" stroke="currentColor" stroke-width="1.6"></path>' +
      '<path d="M8 12l3 3 5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</svg>' +
    '</span>' +
    '<div>' +
      '<div class="allin-nfm__trust-title">Third-party tested for purity</div>' +
      '<div class="body-sm allin-nfm__trust-sub">Every batch tested for heavy metals, microbials, allergens, and label-claim accuracy by Eurofins.</div>' +
    '</div>' +
  '</div>';

  // Which products does THIS page actually link to? Scan the page's facts
  // triggers and map each to a product (chocolate/vanilla → shake).
  function pageProducts() {
    var set = {};
    document.querySelectorAll('[data-bx-nutrition]').forEach(function (el) {
      var v = (el.getAttribute('data-bx-nutrition') || '').trim();
      if (v === 'all') { set.shake = true; set.metab = true; set.bloat = true; return; }
      set[(v === 'metab' || v === 'bloat') ? v : 'shake'] = true;
    });
    return set;
  }

  // Tabs are built ONCE and then only have their --on class toggled. Rebuilding the
  // innerHTML on every open/switch recreated the <img> elements (visible flash) and
  // killed the design's transitions: the pill background fade and the product photo's
  // pop-under nudge (translateY transition on .allin-nfm__tab--on img).
  var tabsBuilt = false;
  function buildTabs() {
    // Product tabs only make sense where the page covers more than one product
    // (the all-in-one bundle). On a single-product page (shake / metab / bloat)
    // show no cross-product tabs — just that product's facts.
    var avail = pageProducts();
    var shown = TABS.filter(function (t) { return avail[t.id]; });
    if (shown.length <= 1) {
      // Single-product page: no cross-product tabs. Render a PDP-style eyebrow in the
      // head instead (matches the single-product panels' header treatment) and switch
      // the head to its row layout.
      var only = shown[0] || TABS[0];
      var EYEBROWS = { shake: 'Superfood Shake \u00b7 Powder', metab: 'Metabolism Booster \u00b7 Capsule', bloat: 'Bloating Relief \u00b7 Capsule' };
      tabsEl.innerHTML = '<span class="mono-sm allin-nfm__eyebrow">' + (EYEBROWS[only.id] || esc(only.lbl)) + '</span>';
      panel.classList.add('allin-nfm--single');
      tabsBuilt = true;
      return;
    }
    panel.classList.remove('allin-nfm--single');
    var html = '';
    shown.forEach(function (t) {
      html += '<button type="button" class="allin-nfm__tab" data-nutrition-tab="' + t.id + '">' +
        '<span class="allin-nfm__tab-img" aria-hidden="true"><img src="' + t.img + '" alt="" width="40" height="40"></span>' +
        '<span class="allin-nfm__tab-lbl">' + esc(t.lbl) + '</span>' +
      '</button>';
    });
    tabsEl.innerHTML = html;
    tabsBuilt = true;
  }
  function renderTabs() {
    if (!tabsBuilt) buildTabs();
    var btns = tabsEl.querySelectorAll('[data-nutrition-tab]');
    // Suppress animations, flip classes, force a reflow, then release: the inline-style
    // poke + reflow makes the class flip's static styles actually land (class toggles
    // alone can leave computed styles pinned — the theme-wide stuck-style quirk), and
    // releasing restarts the @keyframes cleanly so the design's activation pop plays.
    btns.forEach(function (b) {
      b.style.animation = 'none';
      var i = b.querySelector('img'); if (i) i.style.animation = 'none';
    });
    btns.forEach(function (b) {
      b.classList.toggle('allin-nfm__tab--on', b.getAttribute('data-nutrition-tab') === state.product);
    });
    void tabsEl.offsetWidth;
    btns.forEach(function (b) {
      b.style.animation = '';
      var i = b.querySelector('img'); if (i) i.style.animation = '';
    });
  }

  function renderFlavors() {
    if (state.product !== "shake") {
      flavorsEl.innerHTML = '';
      flavorsEl.hidden = true;
      return;
    }
    flavorsEl.hidden = false;
    var html = '';
    FLAVORS.forEach(function (fl) {
      var sel = state.flavor === fl.id;
      html += '<button type="button" role="tab" aria-selected="' + (sel ? "true" : "false") + '"' +
        ' class="allin-nfm__flavor' + (sel ? " allin-nfm__flavor--on" : "") + '" data-nutrition-flavor="' + fl.id + '">' +
        esc(fl.lbl) + '</button>';
    });
    flavorsEl.innerHTML = html;
  }

  function renderBody() {
    var body;
    if (state.product === "shake") body = renderShake(state.flavor);
    else if (state.product === "metab") body = renderCapsule(METAB_FACTS, "Metabolism Booster+");
    else if (state.product === "bloat") body = renderCapsule(BLOAT_FACTS, "Bloating Relief+");
    else body = "";
    bodyEl.innerHTML = body + TRUST;
    bodyEl.scrollTop = 0;
  }

  function render() {
    renderTabs();
    renderFlavors();
    renderBody();
  }

  // --- open / close ---------------------------------------------------------
  function open(initial) {
    if (initial === "metab" || initial === "bloat") {
      state.product = initial;
    } else {
      state.product = "shake";
      state.flavor = initial === "vanilla" ? "vanilla" : "chocolate";
    }
    render();
    state.open = true;
    panel.classList.add('nfm--open');
    panel.setAttribute('aria-hidden', 'false');
    back.classList.add('drawer-back--open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    state.open = false;
    panel.classList.remove('nfm--open');
    panel.setAttribute('aria-hidden', 'true');
    back.classList.remove('drawer-back--open');
    document.body.style.overflow = '';
  }

  // --- events ---------------------------------------------------------------
  tabsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nutrition-tab]');
    if (!btn) return;
    state.product = btn.getAttribute('data-nutrition-tab');
    render();
  });
  flavorsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nutrition-flavor]');
    if (!btn) return;
    state.flavor = btn.getAttribute('data-nutrition-flavor');
    render();
  });

  back.addEventListener('click', close);
  panel.querySelector('[data-nutrition-close]').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) close(); });

  // Any element marked [data-bx-nutrition] opens the panel (defaults to shake).
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bx-nutrition]');
    if (!trigger) return;
    e.preventDefault();
    var initial = trigger.getAttribute('data-bx-nutrition') || undefined;
    open(initial);
  });

  window.BiomeNutrition = { open: open, close: close };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["biome-nutrition-shake"] && !Shopify.designMode) return;
  try {
    (function () {
  var panel = document.querySelector('[data-nfs-panel]');
  var back = document.querySelector('[data-nfs-back]');
  var dataEl = document.querySelector('[data-nfs-data]');
  if (!panel || !back || !dataEl) return;
  var bodyEl = panel.querySelector('[data-nfs-body]');
  var tabs = panel.querySelectorAll('[data-nfs-flavor]');

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var state = { open: false, flavor: 'chocolate' };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var SHIELD = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 2l9 3v6c0 5-4 9-9 10-5-1-9-5-9-10V5l9-3z" stroke="currentColor" stroke-width="1.6"/><path d="M8 12l3 3 5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function renderBody(flavor) {
    var f = DATA.facts;
    var fl = DATA.flavors[flavor] || DATA.flavors.chocolate;
    var html = '';
    html += '<h2 class="h2 nf-shake__title">Nutrition Facts</h2>';
    html += '<div class="nf">';
    html += '<div class="nf__top"><div>' + esc(f.servings) + ' Servings per Container</div><div>Serving size <strong>' + esc(f.serving) + '</strong></div></div>';
    html += '<div class="nf__cal"><span class="nf__cal-l">Calories</span><span class="nf__cal-v">' + esc(f.calories) + '</span></div>';
    html += '<div class="nf__head"><span>Amount per Serving</span><span>% Daily Value*</span></div>';
    f.rows.forEach(function (r) {
      var rv = r.v, rdv = r.dv;
      if (fl.factsOverride && fl.factsOverride[r.l]) { rv = fl.factsOverride[r.l][0]; rdv = fl.factsOverride[r.l][1]; }
      var cls = 'nf__row' + (r.bold ? ' nf__row--bold' : '') + (r.indent ? ' nf__row--indent' : '');
      html += '<div class="' + cls + '"><span>' + esc(r.l) + '</span><span class="nf__row-v">' + esc(rv) + '</span><span class="nf__row-dv">' + esc(rdv) + '</span></div>';
    });
    html += '<div class="nf__divider"></div>';
    f.vitamins.forEach(function (vit) {
      html += '<div class="nf__row nf__row--vit"><span>' + esc(vit[0]) + '</span><span class="nf__row-v">' + esc(vit[1]) + '</span><span class="nf__row-dv">' + esc(vit[2]) + '</span></div>';
    });
    html += '<div class="nf__foot">* The % Daily Value (DV) tells you how much a nutrient in a serving of food contributes to a daily diet. 2,000 calories a day is used for general nutrition advice.</div>';
    html += '</div>';
    html += '<h2 class="h2 nf-shake__title nf-shake__title--ing">Ingredients</h2>';
    html += '<p class="body-md nf-shake__ingredients">' + esc(fl.ingredients) + '</p>';
    html += '<div class="nf-shake__tested"><span class="nf-shake__tested-icon">' + SHIELD + '</span>' +
      '<div><div class="nf-shake__tested-title">Third-party tested for purity</div>' +
      '<div class="body-sm nf-shake__tested-sub">Every batch tested for heavy metals, microbials, allergens, and label-claim accuracy by Eurofins.</div></div></div>';
    return html;
  }

  function setFlavor(flavor) {
    if (!DATA.flavors[flavor]) return;
    state.flavor = flavor;
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-nfs-flavor') === flavor;
      t.classList.toggle('nfm__tab--on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    bodyEl.innerHTML = renderBody(flavor);
  }

  function open(initial) {
    if (initial === 'vanilla' || initial === 'chocolate') setFlavor(initial);
    else setFlavor(state.flavor);
    state.open = true;
    panel.classList.add('nfm--open');
    panel.setAttribute('aria-hidden', 'false');
    back.classList.add('drawer-back--open');
    document.body.style.overflow = 'hidden';
    if (bodyEl) bodyEl.scrollTop = 0;
  }
  function close() {
    state.open = false;
    panel.classList.remove('nfm--open');
    panel.setAttribute('aria-hidden', 'true');
    back.classList.remove('drawer-back--open');
    document.body.style.overflow = '';
  }

  tabs.forEach(function (t) {
    t.addEventListener('click', function () { setFlavor(t.getAttribute('data-nfs-flavor')); });
  });
  back.addEventListener('click', close);
  panel.querySelector('[data-nfs-close]').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) close(); });
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bx-nutrition]');
    if (!trigger) return;
    e.preventDefault();
    var initial = trigger.getAttribute('data-bx-nutrition') || undefined;
    open(initial);
  });

  // Pre-render so the first open paints instantly.
  setFlavor(state.flavor);
  window.BiomeNutrition = { open: open, close: close };
})();
  } catch(e) { console.error(e); }
})();

})();
